import { useContext } from 'react'

import { HeaderSetterContext } from '@context/headerContext'

export function useHeaderSetter() {
  return useContext(HeaderSetterContext)
}
